module.exports = __webpack_public_path__ + "img/cloverGreen.5c21843b.png";